export const drawerDesignToken = {
	background: '{primary.950}',
	border: {
		radius: '0',
		color: '{primary.900}',
	},
	header: {
		padding: '2.5rem 2.5rem 1rem 2.5rem',
	},
	title: {
		font: {
			size: '5rem',
			weight: '600',
		},
	},
	color: 'white',
};
